<template>
  <div class="data-grid-container" data-testid="data-grid-table">
    <slot name="search"></slot>
    <div class="data-grid-wrapper">
      <slot name="header"></slot>
      <slot></slot>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script setup lang="ts">
import { provide } from 'vue';

interface Props {
  striped?: boolean;
  hoverable?: boolean;
  compact?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  striped: false,
  hoverable: true,
  compact: false,
});

// Provide table configuration to child components
provide('dataGridConfig', {
  striped: props.striped,
  hoverable: props.hoverable,
  compact: props.compact,
});
</script>

<style scoped>
.data-grid-container {
  @apply bg-white dark:bg-zinc-800 rounded-lg shadow dark:shadow-zinc-900/20 overflow-hidden;
}

.data-grid-wrapper {
  @apply overflow-x-auto;
  display: table;
  width: 100%;
}
</style>